import { render } from "./Images.vue?vue&type=template&id=b242c6e8"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PageTitle from "@/components/PageTitle.vue";
import UploadImage from "@/components/UploadImage.vue";
script.components = Object.assign({}, { Breadcrumbs, PageTitle, UploadImage }, script.components);